<template>
<div class="container" id="post_wrap">
	
	<div v-if="show_form == 1">
		<h4 class="gold">Add new Post</h4>
		
		<b-card>
			<div class="row">
				<div class="col-md-12">
					<b-form @submit="postAdd">
					
						<b-form-group>
							<label class="gold"><small>Select Category</small></label>
							<b-form-select v-model="category_slug" :options="categories"></b-form-select>
						</b-form-group>
					
						<b-form-group>
							<label class="gold"><small>Subject Header</small></label>
							<b-form-input
								id="title"
								v-model="reply.title"
								type="text"
								required
								placeholder="Enter Subject Header"
								maxlength="150"
							></b-form-input>
						</b-form-group>
						
						<b-form-group>
							<label><small class="gold">
							* To post a YouTube or Vimeo video, just paste the URL into the textarea below (each video link on a new line).
							</small></label>
							<b-form-textarea
								id="textarea"
								v-model="reply.main_text"
								placeholder="What have you got to say?"
								rows="20"
								max-rows="20"
							></b-form-textarea>
						</b-form-group>
						
						
						<h5 v-if="error_message != ''" v-text="error_message" class="text-danger"></h5>
						
						<b-button type="submit" variant="primary">
							<i class="far fa-hand-point-right"></i> Post Reply
						</b-button>
						
						<b-button type="button" variant="outline-secondary" @click="history_back">
							<i class="fas fa-times"></i> Cancel
						</b-button>
					</b-form>

				</div>
			</div>
		</b-card>

	</div>
	
	<div v-else>
		<div class="text-center gold my-2 p-2">
			<b-spinner class="align-middle"></b-spinner>
			<br />
			<strong>Loading...</strong>
		</div>
	</div>
	

  
	
</div>
</template>


<script>
import axios from "axios";

export default {
	name: "PostAdd",
	props: {
	},
	data() {
		return {
			categories: [],
			category_slug: 'general_discussion',
			error_message: '',
			reply: {
				title: '',
				main_text: '',
			},
			session_id: this.$store.state.session_id,
			show_form: 0,
			temp : null,
		}
	},
	computed:{
	},
	methods:{
		
		categoriesGet(){
			let _this = this;
			
			this.categories = [];

			let params = new URLSearchParams();
			params.append('token', this.session_id);

			axios({
				url: _this.$store.state.api_url + "forum/categoriesGet",
				params: params,

			}).then(function (response) {
				
				if(response.data){
					const entries = Object.entries(response.data);
					for (const [k, obj] of entries) {
						var temp = {
							value: k,
							text: obj.title,
						};
						_this.categories.push(temp);
					}
					
					_this.show_form = 1;
				}
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
		categorySetSelected(){
			var category_slug = 'general_discussion';
			
			if(this.$route.params.slug){
				const slug = this.$route.params.slug;
				const find = this.$store.getters.categoriesGet.filter(function(e) {
					return (e.slug === slug);
				});
				if(find.length > 0){
					category_slug = slug;
				}
			}
			this.category_slug = category_slug;
		},
		
		history_back(){
			this.$router.go(-1);
		},
		
		postAdd(e){
			let _this = this;
			e.preventDefault();
			
			console.log('postAdd');

			let params = new URLSearchParams();
			params.append('token', this.session_id);
			params.append('category_slug', this.category_slug);
			params.append('title', this.reply.title);
			params.append('main_text', this.reply.main_text);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + "forum/postAdd",
				data: params,

			}).then(function (response) {
				if(response.data.status == 1){
					_this.$router.push('/forum/post/' + response.data.post_id);
				}
				else{
					_this.error_message = response.data.message;
				}
				
			}).catch(function (error) {
				console.log(error);
			});
		},

	},
	mounted() {
		this.categoriesGet();
		this.categorySetSelected();
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
